<div class="rating-wrap" *ngIf="rating.show">
  <div class="label" *ngIf="label">{{isSchool ? ('school-card.rating' | translate) : ('teacher-card.stats.rating' | translate)}}</div>
  <app-icon class="rating-icon" [height]="16" [width]="16" [icon]="'rating'"></app-icon>
  <span class="rating">{{ rating.rate | numberRound }}</span>
  <span class="reviews" (click)="feedback()">
    ({{ rating.count }}<ng-template [ngIf]="reviewLabel"> {{'library.user-service-card.reviews' | translate}}</ng-template>)
  </span>
</div>
